var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSound = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5265 0.120209C12.2764 0.00225222 11.6762 -0.0775238 11.4409 0.120255L4.77664 5.73523H1.43702C0.64522 5.73523 0 6.37334 0 7.1564V12.8411C0 13.6255 0.64522 14.2622 1.43702 14.2622H4.77664L11.4409 19.9468C11.5716 20.0492 12.2105 19.9723 12.2105 19.9723C12.2105 19.9723 12.4273 19.9227 12.5265 19.8758C12.7751 19.7579 12.9331 19.5092 12.9331 19.2363V0.761154C12.9331 0.488291 12.7751 0.239587 12.5265 0.120209Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1033 4.97353C15.8234 4.69782 15.3743 4.70209 15.0986 4.97921C14.8229 5.25918 14.8257 5.70827 15.1043 5.9854C16.1786 7.04559 16.7698 8.47102 16.7698 9.99877C16.7698 11.5265 16.1786 12.952 15.1043 14.0121C14.8257 14.2864 14.8229 14.7369 15.0986 15.0169C15.2378 15.1576 15.4212 15.2272 15.6031 15.2272C15.7836 15.2272 15.9641 15.159 16.1033 15.0212C17.4506 13.6952 18.191 11.9102 18.191 9.99877C18.191 8.0873 17.4506 6.30232 16.1033 4.97353Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-sound.3481796f1473b80fa150608042ca2c09.svg";